import { SVGProps } from 'react';

export default function Moon(props: Partial<SVGProps<any>>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none" preserveAspectRatio='none' {...props}>
      <path d="M29.6667 19.3332C29.6667 25.2242 24.8911 29.9998 19 29.9998C13.109 29.9998 8.33337 25.2242 8.33337 19.3332C8.33337 13.4421 13.109 8.6665 19 8.6665C24.8911 8.6665 29.6667 13.4421 29.6667 19.3332Z" fill="#F2F2F2" />
      <rect x="37.6666" y="18" width="2.66667" height="5.33333" transform="rotate(90 37.6666 18)" fill="#F2F2F2" />
      <rect x="5.66656" y="18" width="2.66667" height="5.33333" transform="rotate(90 5.66656 18)" fill="#F2F2F2" />
      <rect x="17.6666" y="0.666504" width="2.66667" height="5.33333" fill="#F2F2F2" />
      <rect x="17.6666" y="32.6665" width="2.66667" height="5.33333" fill="#F2F2F2" />
      <rect x="33.142" y="31.5898" width="2.66667" height="5.33333" transform="rotate(135 33.142 31.5898)" fill="#F2F2F2" />
      <rect x="10.5146" y="8.9624" width="2.66667" height="5.33333" transform="rotate(135 10.5146 8.9624)" fill="#F2F2F2" />
      <rect x="31.2564" y="5.19092" width="2.66667" height="5.33333" transform="rotate(45 31.2564 5.19092)" fill="#F2F2F2" />
      <rect x="8.62897" y="27.8184" width="2.66667" height="5.33333" transform="rotate(45 8.62897 27.8184)" fill="#F2F2F2" />
    </svg>
  )
}